import React, { Component, createElement } from 'react'

import Linka from 'client/shared/blocks/linka'
import urlFor, { QueryParams } from 'shared/tools/url-helper'

import './user.styl'

import { UserAvatar } from 'client/shared/blocks/user-avatar'
import MetaCounters from 'client/bookmate/blocks/meta-counters'
import PlusBox from 'client/shared/boxes/plus-box'
import { ReadingProgressBar } from 'client/bookmate/blocks/reading-progress-bar'

import { UserShort } from 'client/shared/types/user'
import { CurrentUserData } from 'client/shared/types/current-user'

type ReadingStatsProps = {
  finishedBooksCount: number | null | undefined
  promisedBooksCount: number | null | undefined
}

type Kind = 'list' | 'card' | 'with-progress' | 'with-progress-self'

type Props = {
  user: UserShort | CurrentUserData
  kind: Kind
  showPlus: boolean
  readingStats?: ReadingStatsProps
  isLoggedIn?: boolean
  showAuthPopup?: () => void
  query?: QueryParams
  as?: string
}

export class User extends Component<Props> {
  static defaultProps = {
    showPlus: true,
  }

  prepareLink(kind: Kind, login: string): string {
    switch (kind) {
      case 'with-progress':
      case 'with-progress-self': {
        const currentYear = new Date().getFullYear()
        return urlFor.userAchievements(login, currentYear, this.props.query)
      }
      default:
        return urlFor.user(login, this.props.query)
    }
  }

  getCounters(): { kind: string; count?: number }[] {
    const {
      user: { bookshelves_count, library_cards_count, followers_count },
    } = this.props

    return [
      { kind: 'books', count: library_cards_count },
      { kind: 'users', count: followers_count },
      { kind: 'shelves', count: bookshelves_count },
    ].filter(({ count }) => typeof count === 'number' && count > 0)
  }

  render(): JSX.Element {
    const {
      user,
      user: { name, login, id },
      kind,
      showPlus,
      readingStats,
      as = 'div',
    } = this.props
    const username = name || login
    const counters = this.getCounters()
    const size = 40

    const UserElement = createElement(as, {
      className: `user user_${kind}`,
      children: (
        <>
          <div className="user__pic">
            <UserAvatar user={user} size={size} />
          </div>
          <div className="user__info">
            <Linka
              title={username}
              className="user__name"
              path={this.prepareLink(kind, login)}
              loginWall
              pseudo
            >
              {username}
            </Linka>
            {['list'].includes(kind) && Boolean(counters.length) && (
              <MetaCounters counters={counters} />
            )}
            {['with-progress', 'with-progress-self'].includes(kind) &&
              readingStats && (
                <ReadingProgressBar
                  finishedBooksCount={readingStats.finishedBooksCount}
                  promisedBooksCount={readingStats.promisedBooksCount}
                />
              )}
          </div>
          <div className="user__follow">
            {['list'].includes(kind) && showPlus && (
              <PlusBox key={id} user={user} />
            )}
          </div>
        </>
      ),
    })

    return UserElement
  }
}
